import React, { useEffect, useState } from "react";
import _ from "lodash";
import { Button, FormLayout, Heading, Input } from "@/ui";
import { useForm, useValidator } from "@/hooks";
import styles from "./OnFleetForm.module.scss";

const fieldError = (validator, name) =>
    validator?.[name]?.isInvalid ? validator[name].message : undefined;

const OnFleetMerchantForm = ({
    app,
    handleCancel,
    handlerUpdatingOrCreate,
    isCreate,
    isUpdating,
    selectMerchant,
    setMerchants,
}) => {
    const [isFormReset, resetFormInputs] = useState(isCreate);
    const { inputs, inputChange, setInputs } = useForm();

    const { validator, isValid, isSubmited } = useValidator(
        [
            {
                field: "store_id",
                method: "isEmpty",
                validWhen: false,
                message: "This Store Id is required.",
            },
            {
                field: "merchant",
                method: "isEmpty",
                validWhen: false,
                message: "This Merchant is required.",
            },
        ],
        {
            ...inputs,
        },
    );

    useEffect(() => {
        if (!isCreate) {
            const objSelect = app?.merchants[selectMerchant];
            setInputs({
                store_id: objSelect?.store_id,
                merchant: objSelect?.merchant,
            });
        }
    }, []);

    if (!isCreate && !isFormReset) {
        resetFormInputs(true);
    }

    const createOrUpdate = async () => {
        if (isSubmited) {
            isSubmited(true);
        }

        if (isValid()) {
            const newMerchants = _.cloneDeep(app.merchants || []);

            if (isCreate) {
                newMerchants.push({
                    store_id: inputs.store_id,
                    merchant: inputs.merchant,
                });
            } else {
                newMerchants[selectMerchant] = {
                    ...inputs,
                    store_id: inputs.store_id,
                    merchant: inputs.merchant,
                };
            }
            setMerchants(newMerchants);
            handlerUpdatingOrCreate(newMerchants);
        }
    };

    const handleClose = () => {
        handleCancel();
        resetFormInputs(false);
    };

    return (
        <div className={styles.merchantForm}>
            <Heading level={5}>
                {isCreate ? "Add Merchant" : "Update Merchant"}
            </Heading>

            <FormLayout>
                <FormLayout.Grid columns={2} maxWidth="twoThirds">
                    <Input
                        error={fieldError(validator, "store_id")}
                        fullWidth
                        label="Store Id"
                        name="store_id"
                        onChange={inputChange}
                        placeholder="Store Id"
                        value={inputs.store_id || ""}
                    />
                    <Input
                        error={fieldError(validator, "merchant")}
                        fullWidth
                        label="Merchant"
                        name="merchant"
                        onChange={inputChange}
                        placeholder="Merchant"
                        value={inputs.merchant || ""}
                    />
                </FormLayout.Grid>
            </FormLayout>

            <div className={styles.merchantActions}>
                <Button
                    disabled={isUpdating}
                    onClick={handleClose}
                    type="button"
                    variant="secondary"
                >
                    Cancel
                </Button>
                <Button
                    loading={isUpdating}
                    onClick={createOrUpdate}
                    type="button"
                >
                    Save
                </Button>
            </div>
        </div>
    );
};

export default OnFleetMerchantForm;
